module.exports = __webpack_public_path__ + "static/media/icons8-delete-yellow.2468a566.svg";